import { useState } from "react";
import { Check, Link2 } from "lucide-react";

const SHARE_TEXT = "Join me for BACK TO YOU — Crystal Stretch's FREE 14-Day Metabolic Reset. Registration is free:";

export default function SuccessCard({ idPrefix, dark, labelCls }) {
  const [copied, setCopied] = useState(false);
  const url = window.location.origin;

  const share = async () => {
    if (navigator.share) {
      try {
        await navigator.share({ title: "BACK TO YOU — FREE 14-Day Metabolic Reset", text: SHARE_TEXT, url });
        return;
      } catch {}
    }
    try {
      await navigator.clipboard.writeText(url);
    } catch {
      const ta = Object.assign(document.createElement("textarea"), { value: url });
      document.body.appendChild(ta); ta.select(); document.execCommand("copy"); ta.remove();
    }
    setCopied(true);
    setTimeout(() => setCopied(false), 2500);
  };

  return (
    <div data-testid={`${idPrefix}-success-message`} className={`rounded-3xl p-10 text-center ${dark ? "bg-[#FFFFFF]/10 border border-[#A89DE3]/30" : "bg-white border border-[#E3E3F0]"}`}>
      <p className={`font-display font-extrabold text-3xl ${dark ? "text-[#FFFFFF]" : "text-[#0B0B12]"}`}>YOU'RE IN.</p>
      <p className={`mt-4 leading-relaxed ${labelCls}`}>
        Your registration is in. Watch your inbox (and your phone) — your invitation to the app and next steps are on the way.
        Get ready to get BACK TO YOU.
      </p>
      <p className={`mt-8 text-xs font-semibold uppercase tracking-[0.2em] ${dark ? "text-[#A89DE3]" : "text-[#1B2FD8]"}`}>
        Know another woman who needs this?
      </p>
      <button
        data-testid={`${idPrefix}-share-button`}
        type="button"
        onClick={share}
        className={`mt-3 inline-flex items-center gap-2 rounded-full px-6 py-3 font-display font-bold tracking-wide transition-colors duration-300 ${
          copied ? "bg-[#4B2A9E] text-[#FFFFFF]" : dark ? "bg-[#FFFFFF] text-[#0B0B12] hover:bg-[#1B2FD8] hover:text-[#FFFFFF]" : "bg-[#0B0B12] text-[#FFFFFF] hover:bg-[#1B2FD8]"
        }`}
      >
        {copied ? <Check size={18} /> : <Link2 size={18} />}
        {copied ? "LINK COPIED" : "SEND THIS TO A FRIEND"}
      </button>
    </div>
  );
}
